import { isGlamping } from '~/utility/glamping'
import { SearchFilters } from '../../search/schemas'
import { SearchLinkGenerator } from '../../url/generators/SearchLinkGenerator'
import { CATEGORIES } from '../simpleCategories'
import { Breadcrumb } from './types'

export const HIERARCHY_REGION = 2
export const HIERARCHY_COUNTY = 3
export const HIERARCHY_TOWN = 4

export interface HierarchyPart {
  name: string
  path: string
  level: number
}

export function getHierarchyBreadcrumbs({
  hierarchies,
  filters,
  noCategories = false,
}: {
  hierarchies: HierarchyPart[]
  filters: SearchFilters
  noCategories?: boolean
}): Breadcrumb[] {
  const category = noCategories
    ? 'campsites'
    : getLinkCategory(filters.categoryIds)
  const linkFilters = noCategories ? filters : getLinkFilters(filters)
  return hierarchies.map((hierarchy) =>
    getHierarchyBreadcrumb(hierarchy, linkFilters, category, noCategories),
  )
}

function getHierarchyBreadcrumb(
  hierarchy: HierarchyPart,
  filters: SearchFilters,
  category: string,
  noCategories: boolean,
): Breadcrumb {
  const { name: label, path: hierarchyPath } = hierarchy
  const linkGenerator = new SearchLinkGenerator({ noCategories })
  const to = linkGenerator.getUrlData({
    category,
    filters,
    hierarchyPath,
    customQueryParams: {
      pitchtype: undefined,
    },
  })
  const level = hierarchyPath.split('/').length - 1
  return { label, to, hierarchyPath, level }
}

function getLinkCategory(categories: SearchFilters['categoryIds']): string {
  if (categories && categories.length === 1) {
    return CATEGORIES[categories[0]]
  } else if (isGlamping(categories || [])) {
    return 'glamping'
  }
  return 'campsites'
}

function getLinkFilters(filters: SearchFilters): SearchFilters {
  return isGlamping(filters.categoryIds || []) ||
    filters.categoryIds?.length === 1
    ? { ...filters, categoryIds: null }
    : filters
}
